var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9987 8.33398V22.5007M19.9987 22.5007L24.9987 17.5007M19.9987 22.5007L14.9987 17.5007M8.33203 25.0007V28.334C8.33203 29.218 8.68322 30.0659 9.30834 30.691C9.93346 31.3161 10.7813 31.6673 11.6654 31.6673H28.332C29.2161 31.6673 30.0639 31.3161 30.6891 30.691C31.3142 30.0659 31.6654 29.218 31.6654 28.334V25.0007",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.b3b2f461f2f742756cc0f7b124a7366e.svg";
export { ForwardRef as ReactComponent };